import { Injectable } from '@angular/core';
import { SharedHttpClientService } from 'app/Shared/Services/shared-http-client.service';
import { UrlsService } from 'app/Shared/Services/urls.service';
import { UserService } from 'app/Shared/Services/user.service';
import { APIURL } from 'app/Shared/Constant/API_Urls';

@Injectable(
  {providedIn: 'root'}
)
export class ExceptionDetailsService {

  constructor(private sharedHttpClientService: SharedHttpClientService,
    private urlsService: UrlsService, 
    private userService: UserService) { }
  getUserList() {
    return this.sharedHttpClientService.post(
      this.urlsService.setAPIURl(
        APIURL.Exception_User_List
        ), {
          mpid: this.userService.getActiveMPID()
        })      
  }
  updateClientDataExceptionStatus(data: any) {
    return this.sharedHttpClientService.post(
      this.urlsService.setAPIURl(
        APIURL.Exception_Update_Client_Data_Exception_Status
        ), data)     
  }
  getClientDataException(data: any) {
    return this.sharedHttpClientService.post(
      this.urlsService.setAPIURl(
        APIURL.Exception_Client_Data_Exception_Details
        ), data)     
  }

  getGraphData(data: any) {
    return this.sharedHttpClientService.post(
      this.urlsService.setAPIURl(
        APIURL.Exception_Market_Data_Graph
        ), data) 
  }

  getExceptionList(data: any) {
    return this.sharedHttpClientService.post(
      this.urlsService.setAPIURl(
        APIURL.Exception_Exception_List
        ), data) 
  }

  getClientData(url: any, filterData: any, limit: any, pageName: string,eventType: string,exceptionId: any) {
     let Data = {
            "data": filterData,
            "mpid": this.userService.getActiveMPID(),
            "startLimit": limit.Start + "",
            'endLimit': limit.End + "",
            'pageName': pageName,
            'eventType': eventType,
            'exceptionId': exceptionId
        };
    return this.sharedHttpClientService.post(this.urlsService.setAPIURl(url), Data);

  }
}
